import { MAILROOM_NATIVE_APP_ID, NativeAppStatus } from 'utils/nativeApps';
import { useMemo } from 'react';
import { useFeatureFlag } from './useFeatureFlag';
import { useOpQuery } from './useOpQuery';

export const useIsMailroomEnabled = ({ orgId }: { orgId: number }) => {
  const { data: orgNativeApps } = useOpQuery({
    apiEndpointName: 'listOrgNativeApps',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse.json.data ?? [],
  });

  const hasMailroomNativeApp = orgNativeApps?.some(
    (app) =>
      app.nativeAppId === MAILROOM_NATIVE_APP_ID &&
      app.status === NativeAppStatus.Active,
  );

  // TODO - Hide mailroom in table for now. Update when no longer determined by a feature flag.
  const { value: isMailroomEnabledFF } = useFeatureFlag<Boolean>(
    'ENABLE_MAILROOM',
    orgId,
  );

  const isMailroomEnabled = useMemo(() => {
    return hasMailroomNativeApp || isMailroomEnabledFF;
  }, [hasMailroomNativeApp, isMailroomEnabledFF]);

  return isMailroomEnabled;
};
